/* =====================================================================
   PB NAV (v0.1) — desktop-menu (hover-intent, tastatur), mobilmenu
   (flydende panel, håndtag + træk op/ned for at lukke, én gruppe åben ad gangen),
   land/valuta skifter med det samme.
   Træk-for-at-lukke: kun passive lyttere + touch-action:none på top-rækken
   (browseren kan ikke "stjæle" trækket, og listen scroller uden forsinkelse).
   ===================================================================== */
(function () {
  'use strict';
  var d = document, PB = window.PB;
  if (!PB) return;

  PB.ready(function () {
    /* ---------- land/valuta ---------- */
    d.addEventListener('change', function (e) {
      var s = e.target.closest('[data-pb-loc]'); if (s && s.form) s.form.submit();
    });

    /* ---------- desktop ---------- */
    var nav = d.querySelector('[data-pb-nav]');
    if (nav) {
      var openItem = null, tIn = null, tOut = null;
      /* Skift mellem menupunkter: panelets ramme bliver stående (intet gennemsigtigt blink af siden bagved),
         højden glider mildt til det nye panel, og kun indholdet toner ind. Åbning fra lukket og lukning er som før.
         Slås fra ved "reducer bevægelse". */
      var swapT = null, calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function boxOf(li) { return li && li.querySelector('.pb-mega__in'); }
      function unlock(bx) { if (bx) { bx.style.height = ''; bx.style.overflow = ''; bx.style.transition = ''; } }
      function setOpen(li) {
        if (openItem === li) return;
        var prev = openItem, pb = boxOf(prev), nb = boxOf(li), swap = !!(pb && nb);
        var h0 = swap ? pb.getBoundingClientRect().height : 0;
        nav.classList.toggle('is-swap', swap);
        clearTimeout(swapT);
        if (prev) { prev.classList.remove('is-open', 'is-swapin'); unlock(pb); var a = prev.querySelector('.pb-nav__top'); if (a) a.setAttribute('aria-expanded', 'false'); closeFly(prev); }
        openItem = li;
        if (li) { li.classList.add('is-open'); var b = li.querySelector('.pb-nav__top'); if (b) b.setAttribute('aria-expanded', 'true'); }
        if (!swap || calm) return;
        unlock(nb); var h1 = nb.getBoundingClientRect().height;
        if (Math.abs(h1 - h0) > 2) { nb.style.overflow = 'hidden'; nb.style.height = h0 + 'px'; nb.getBoundingClientRect(); nb.style.transition = 'height .24s cubic-bezier(.2,.8,.2,1)'; nb.style.height = h1 + 'px'; }
        li.classList.add('is-swapin');
        swapT = setTimeout(function () { unlock(nb); li.classList.remove('is-swapin'); }, 300);
      }
      function closeFly(root) { Array.prototype.forEach.call(root.querySelectorAll('.pb-panel__item.is-open'), function (x) { x.classList.remove('is-open'); }); }
      nav.addEventListener('pointerover', function (e) {
        if (e.pointerType !== 'mouse') return;
        var li = e.target.closest('.pb-nav__item.has-panel'); clearTimeout(tOut);
        if (li) { clearTimeout(tIn); tIn = setTimeout(function () { setOpen(li); }, openItem ? 70 : 60);   /* 70 ms ved skift: musen kan glide hen over andre punkter uden at hver af dem åbner */ }
        var fi = e.target.closest('.pb-panel__item');
        if (fi) { var p = fi.parentElement; Array.prototype.forEach.call(p.children, function (x) { if (x !== fi) x.classList.remove('is-open'); }); if (fi.classList.contains('has-fly')) fi.classList.add('is-open'); }
      });
      nav.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'mouse') return; clearTimeout(tIn); tOut = setTimeout(function () { setOpen(null); }, 140); });
      nav.addEventListener('focusin', function (e) { var li = e.target.closest('.pb-nav__item.has-panel'); setOpen(li || null); var fi = e.target.closest('.pb-panel__item.has-fly'); if (fi) fi.classList.add('is-open'); });
      nav.addEventListener('focusout', function () { setTimeout(function () { if (!nav.contains(d.activeElement)) setOpen(null); }, 0); });
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openItem) { var a = openItem.querySelector('.pb-nav__top'); setOpen(null); if (a) a.focus(); } });
      /* touch på tablet: første tryk åbner panelet, andet følger linket */
      nav.addEventListener('click', function (e) {
        var top = e.target.closest('.pb-nav__top'); if (!top) return;
        var li = top.parentElement;
        if (li.classList.contains('has-panel') && !li.classList.contains('is-open') && matchMedia('(hover: none)').matches) { e.preventDefault(); setOpen(li); }
      });
    }

    /* ---------- mobil (v2): flydende kort som kurven, visninger der glider ind, træk ned for at lukke ---------- */
    var m = d.querySelector('[data-pb-mnav]');
    if (!m) return;
    var panel = m.querySelector('.pb-mnav__panel'), head = m.querySelector('[data-pb-mnav-drag]');
    var back = m.querySelector('[data-pb-mn-back]'), title = m.querySelector('[data-pb-mn-title]');
    var openers = d.querySelectorAll('[data-pb-mnav-open]'), cur = 'main';
    function views() { return Array.prototype.slice.call(m.querySelectorAll('[data-view]')); }
    function view(id) { return m.querySelector('[data-view="' + id + '"]'); }
    function show(id) {
      var v = view(id); if (!v) return;
      cur = id;
      views().forEach(function (x) { var on = x === v; x.classList.toggle('is-on', on); x.setAttribute('aria-hidden', on ? 'false' : 'true'); });
      if (title) title.textContent = v.getAttribute('data-title') || '';
      if (back) back.hidden = id === 'main';
      panel.style.setProperty('--lc-cur', getComputedStyle(v).getPropertyValue('--lc') || '');
      if (id !== 'main') v.scrollTop = 0;
    }
    function mOpen() { m.classList.add('is-warm'); show('main'); m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); PB.lock(true); Array.prototype.forEach.call(openers, function (b) { b.setAttribute('aria-expanded', 'true'); }); }
    function mClose() {
      if (!m.classList.contains('is-open')) return;
      m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); PB.lock(false);
      Array.prototype.forEach.call(openers, function (b) { b.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () { if (!m.classList.contains('is-open')) show('main'); }, 450);
    }
    d.addEventListener('click', function (e) {
      if (e.target.closest('[data-pb-mnav-open]')) { e.preventDefault(); m.classList.contains('is-open') ? mClose() : mOpen(); return; }
      if (!m.contains(e.target)) return;
      if (e.target.closest('[data-pb-mnav-close]')) { e.preventDefault(); mClose(); return; }
      var go = e.target.closest('[data-pb-mn-go]'); if (go) { e.preventDefault(); show(go.getAttribute('data-pb-mn-go')); return; }
      if (e.target.closest('[data-pb-mn-back]')) { e.preventDefault(); show('main'); return; }
      /* grupper: glider op/i (CSS), kun én åben ad gangen */
      var gb = e.target.closest('[data-pb-grp]');
      if (gb) {
        var grp = gb.parentElement, op = !grp.classList.contains('is-open'), list = grp.closest('ul');
        if (op && list) Array.prototype.forEach.call(list.querySelectorAll('.pb-mn__grp.is-open'), function (o) { if (o !== grp) { o.classList.remove('is-open'); var ob = o.querySelector('[data-pb-grp]'); if (ob) ob.setAttribute('aria-expanded', 'false'); } });
        grp.classList.toggle('is-open', op); gb.setAttribute('aria-expanded', op ? 'true' : 'false');
      }
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && m.classList.contains('is-open')) { if (cur !== 'main') show('main'); else mClose(); } });
    /* én gruppe åben ad gangen + blød fold-ud: se pb-ui.js */
    /* træk NED for at lukke (fra toppen, eller når listen står øverst) · swipe mod højre = tilbage */
    var sx = null, sy = null, dy = 0, t0 = 0, dragging = false, fromHead = false;
    panel.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; dy = 0; t0 = Date.now(); dragging = false;
      fromHead = !!e.target.closest('[data-pb-mnav-drag]') && !e.target.closest('button,a,select,input');
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (sy === null) return;
      var ddy = e.touches[0].clientY - sy, ddx = e.touches[0].clientX - sx;
      if (!dragging) {
        if (ddy < 8 || Math.abs(ddx) > ddy) return;
        var v = view(cur); if (!fromHead && v && v.scrollTop > 0) return;
        dragging = true; panel.classList.add('is-drag');
      }
      dy = Math.max(0, ddy); e.preventDefault();
      panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: false });
    panel.addEventListener('touchend', function (e) {
      if (sy === null) return;
      if (dragging) {
        var vel = dy / Math.max(1, Date.now() - t0);
        panel.classList.remove('is-drag'); panel.style.transform = '';
        if (dy > 110 || vel > 0.55) mClose();
      } else if (cur !== 'main') {
        var dx = e.changedTouches[0].clientX - sx, ady = Math.abs(e.changedTouches[0].clientY - sy);
        if (dx > 70 && ady < 50) show('main');
      }
      sx = sy = null; dragging = false;
    }, { passive: true });
  });
})();

/* MENU v3 — computer (C1): spillets fliser hentes ved behov (forudindlæses, når musen rammer menuen) · "Alle" + én plade pr. sprog i samme faste felt
   mobil (v3): spil-siden henter det samme ved første tryk; sprogfanerne skifter plade · "starter snart"-nedtælling på Drops/Auktioner */
(function () {
  'use strict';
  var d = document, CACHE = {};
  function url(u) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'section_id=pb-mega&sort_by=best-selling'; }
  /* flise uden billede: typen ligger længere nede end de 250 mest solgte varer, menu-dataen ser (fx nye Graded-kort i Pokémon med 300+ varer)
     → hent spillets data filtreret på typen (flisens eget link) og brug billedet derfra. Kun for fliser, der mangler et billede — ellers intet ekstra kald */
  function pad(box) {
    if (!box) return Promise.resolve();
    var miss = [].filter.call(box.querySelectorAll('.pb-mega__type'), function (a) { var s = a.querySelector('.pb-mega__timg'); return s && !s.querySelector('img') && a.getAttribute('href'); });
    return Promise.all(miss.map(function (a) {
      var href = a.getAttribute('href');
      return fetch(url(href)).then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) {
        var t = d.createElement('div'); t.innerHTML = h;
        var b = [].filter.call(t.querySelectorAll('[data-part="types"] .pb-mega__type'), function (y) { return y.getAttribute('href') === href && y.querySelector('.pb-mega__timg img'); })[0];
        if (b) a.querySelector('.pb-mega__timg').innerHTML = b.querySelector('.pb-mega__timg').innerHTML;
      }).catch(function () {});
    }));
  }
  function get(u) {
    if (!u) return Promise.resolve(null);
    if (!CACHE[u]) CACHE[u] = fetch(url(u)).then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) { var t = d.createElement('div'); t.innerHTML = h; var x = { ty: t.querySelector('[data-part="types"]'), lg: t.querySelector('[data-part="langs"]'), nw: t.querySelector('[data-part="new"]') }; return pad(x.ty).then(function () { return x; }); }).catch(function () { delete CACHE[u]; return null; });
    return CACHE[u];
  }
  /* pladens form: op til 4 fliser på én række (store billeder), ellers to rækker */
  function shape(g) { var n = g.children.length, c = n <= 4 ? Math.max(n, 1) : Math.min(6, Math.ceil(n / 2)); g.style.setProperty('--c', c); g.style.setProperty('--r', n <= 4 ? 1 : 2); }
  function plates(x) {
    var h = '';
    if (x.ty && x.ty.children.length) h += '<div class="pb-mega__grid is-on" data-k="all">' + x.ty.innerHTML + '</div>';
    if (x.lg) [].forEach.call(x.lg.children, function (c) { if (c.children.length) h += '<div class="pb-mega__grid" data-k="' + c.getAttribute('data-k') + '">' + c.innerHTML + '</div>'; });
    return h;
  }
  function fill(root, u) {
    if (!root || !u || root.__pbMega) return; root.__pbMega = 1;
    get(u).then(function (x) {
      if (!x) { root.__pbMega = 0; return; }
      var ty = root.querySelector('[data-pb-mega-types]'), nw = root.querySelector('[data-pb-mega-new]'), h = plates(x);
      if (ty) {
        if (h) { ty.innerHTML = h; [].forEach.call(ty.children, shape); if (!ty.querySelector('.is-on') && ty.firstElementChild) ty.firstElementChild.classList.add('is-on'); }
        else { ty.hidden = true; var p = ty.previousElementSibling; if (p && /pb-(mega__h|mn__label)/.test(p.className)) p.hidden = true; }
      }
      if (nw) nw.innerHTML = x.nw ? x.nw.innerHTML : '';
    });
  }
  /* vis sprogets plade (eller "Alle") */
  function plate(root, k) {
    var box = root.querySelector('[data-pb-mega-types]'); if (!box) return;
    var tgt = box.querySelector('.pb-mega__grid[data-k="' + k + '"]') || box.querySelector('.pb-mega__grid[data-k="all"]');
    if (tgt) [].forEach.call(box.children, function (g) { g.classList.toggle('is-on', g === tgt); });
  }
  function ready(fn) { if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function () {
    var nav = d.querySelector('[data-pb-nav]');
    if (nav) {
      var pre = false;
      function pick(m, lg) { plate(m, lg.getAttribute('data-pb-mega-lang')); [].forEach.call(m.querySelectorAll('[data-pb-mega-lang]'), function (x) { x.classList.toggle('is-on', x === lg); }); }
      function hit(e) {
        var li = e.target.closest('.has-mega'); if (!li) return;
        var m = li.querySelector('[data-pb-mega]'); fill(m, m.getAttribute('data-pb-mega'));
        if (e.target.closest('.pb-nav__top')) { var all = m.querySelector('[data-pb-mega-lang="all"]'); if (all) pick(m, all); }   /* nyt spil → start på "Alle" */
        var lg = e.target.closest('[data-pb-mega-lang]'); if (lg) pick(m, lg);
      }
      nav.addEventListener('pointerover', function (e) {
        if (!pre) { pre = true; nav.classList.add('is-warm'); [].forEach.call(nav.querySelectorAll('[data-pb-mega]'), function (m, i) { setTimeout(function () { get(m.getAttribute('data-pb-mega')); }, i * 120); }); }
        hit(e);
      });
      nav.addEventListener('focusin', function (e) { nav.classList.add('is-warm'); hit(e); });   /* .is-warm: menubillederne må nu hentes (se pb-base.css) */
      var U = { d: nav.getAttribute('data-ud') || 'd', h: nav.getAttribute('data-uh') || 't', m: nav.getAttribute('data-um') || 'm' }, S = nav.getAttribute('data-soon') || '[t]';
      function tick() {
        var now = Date.now() / 1000;
        [].forEach.call(d.querySelectorAll('[data-pb-soon]'), function (el) {
          var s = Math.max(0, Math.round(+el.getAttribute('data-pb-soon') - now)), dd = Math.floor(s / 86400), hh = Math.floor((s % 86400) / 3600), mm = Math.max(1, Math.floor((s % 3600) / 60));
          el.textContent = S.replace('[t]', ((dd ? dd + U.d + ' ' : '') + (hh ? hh + U.h + ' ' : '') + (dd ? '' : mm + U.m)).trim());
        });
      }
      tick(); setInterval(tick, 30000);
    }
    var mn = d.querySelector('[data-pb-mnav]');
    if (mn) {
      function viewOf(go) { return mn.querySelector('[data-view="' + go.getAttribute('data-pb-mn-go') + '"]'); }
      mn.addEventListener('touchstart', function (e) { var go = e.target.closest('[data-pb-mn-go]'), v = go && viewOf(go); if (v) get(v.getAttribute('data-pb-mega-m')); }, { passive: true });
      mn.addEventListener('click', function (e) {
        var go = e.target.closest('[data-pb-mn-go]'), v = go && viewOf(go); if (v) fill(v, v.getAttribute('data-pb-mega-m'));
        var lg = e.target.closest('[data-pb-mn-lang]');
        if (lg) {
          var vw = lg.closest('[data-view]');
          plate(vw, lg.getAttribute('data-pb-mn-lang'));
          [].forEach.call(vw.querySelectorAll('[data-pb-mn-lang]'), function (x) { x.setAttribute('aria-pressed', x === lg ? 'true' : 'false'); });
        }
      });
    }
  });
})();

/* MENUEN PÅ ÉN LINJE (tablets — og med tre piller også på store skærme): ryger et menupunkt ned på en ny linje, gøres menuen trinvis mere kompakt
   (pb-nav--c1 tættere · c2 endnu tættere · c3 13 px · c4 uden "Snart"-mærker · c5 uden ikoner i pillerne · til sidst pb-nav--z: hele rækken skaleres ned med zoom) — se pb-base.css */
(function () {
  function init() {
  var nav = document.querySelector('.pb-nav'), list = nav && nav.querySelector('.pb-nav__list');
  if (!list) return;
  var LV = ['pb-nav--c1', 'pb-nav--c2', 'pb-nav--c3', 'pb-nav--c4', 'pb-nav--c5'];
  function wrapped() {   /* et punkt starter under det første punkts bund = ny linje (Drops/Auktioner er lavere og centreret, så ikke blot offsetTop) */
    var it = [].filter.call(list.children, function (x) { return x.offsetHeight > 0; });
    if (it.length < 2) return false;
    var lim = it[0].offsetTop + it[0].offsetHeight - 2;
    for (var i = 1; i < it.length; i++) if (it[i].offsetTop >= lim) return true;
    return false;
  }
  function fit() {
    LV.forEach(function (c) { nav.classList.remove(c); });
    nav.classList.remove('pb-nav--z'); nav.style.removeProperty('--pb-nav-z');
    if (!list.offsetParent) return;   /* mobil: menuen er skjult */
    for (var i = 0; i < LV.length && wrapped(); i++) nav.classList.add(LV[i]);
    if (!wrapped()) return;
    /* sidste trin: stadig ikke plads (smal skærm + langt sprog + mange piller) → hele rækken skaleres ned (zoom), til den står på én linje */
    var it = [].filter.call(list.children, function (x) { return x.offsetHeight > 0; });
    var cs = getComputedStyle(list), need = (parseFloat(cs.columnGap) || 0) * (it.length - 1);
    var avail = list.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    it.forEach(function (x) { need += x.getBoundingClientRect().width; });
    nav.classList.add('pb-nav--z');
    for (var z = Math.min(1, Math.floor(avail / need * 100) / 100); z > 0.5; z = Math.round((z - 0.02) * 100) / 100) {
      nav.style.setProperty('--pb-nav-z', z);
      if (!wrapped()) break;
    }
  }
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 120); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  fit();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
